import script from "./FileImporterAddData.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileImporterAddData.vue?vue&type=script&setup=true&lang=ts"

import "./FileImporterAddData.vue?vue&type=style&index=0&id=45293728&scoped=true&lang=css"

import exportComponent from "/builds/SalesIT/ijaa/import-tool/ls-import-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45293728"]])

export default __exports__